export const NODE_TYPE_LEAK5S = 'leak5s'
export const NODE_TYPE_NBIOT_LEAK = 'nbiot_leak'

export interface ActivatableDevice {
  displayName: string
  nodeTypeName: string
  nodeId: number | null
}

const nodeTypePriority: Record<string, number> = {
  [NODE_TYPE_LEAK5S]: 0,
  [NODE_TYPE_NBIOT_LEAK]: 1,
}

// Sorts devices by node type priority (Slims first, Leak & Freeze second), then alphabetically by vanity name within the same type.
export const sortDevicesByTypePriority = (devices: ActivatableDevice[]) =>
  [...devices].sort((a, b) => {
    const priorityA = a.nodeTypeName ? (nodeTypePriority[a.nodeTypeName] ?? Number.MAX_SAFE_INTEGER) : Number.MAX_SAFE_INTEGER
    const priorityB = b.nodeTypeName ? (nodeTypePriority[b.nodeTypeName] ?? Number.MAX_SAFE_INTEGER) : Number.MAX_SAFE_INTEGER

    if (priorityA !== priorityB) return priorityA - priorityB

    return (a.displayName ?? '').localeCompare(b.displayName ?? '', undefined, { sensitivity: 'base' })
  })
